import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';
import { NToggle } from '@df/ui/toggle/toggle.service';
import { AppRootComponent } from '../../../app-root.component';
import { AbstractPageSearchFormComponent } from '../../search/form/abstract-page-search-form.component';
import { NPageSearch } from '../../search/page-search.interfaces';
import { NPageOffCanvas } from '../page-off-canvas.component';

@Component({
    selector: 'page-off-canvas-search-form',
    templateUrl: './page-off-canvas-search-form.html',
    styleUrls: ['./page-off-canvas-search-form.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageOffCanvasSearchFormComponent extends AbstractPageSearchFormComponent implements OnInit {
    @ViewChild('input', { read: ElementRef })
    protected input?: ElementRef<HTMLInputElement>;

    private appRootComponent = inject(AppRootComponent);

    static get toggleId(): NToggle.TId {
        return [NPageOffCanvas.OFF_CANVAS_GROUP_ID, NPageSearch.SEARCH_OFF_CANVAS_KEY];
    }

    override ngOnInit(): void {
        this.subscriptions.add(
            this.appRootComponent.offCanvasState.subscribe(state => {
                if (!state) {
                    this.toggleVisibility(false);
                }
            })
        );
        this.subscriptions.add(
            this.toggleService.getState(PageOffCanvasSearchFormComponent.toggleId).subscribe(value => this.toggleVisibility(value))
        );
        super.ngOnInit();
    }

    /**
     * Toggle full component visibility
     */
    toggleVisibility(to: boolean) {
        if (this.isVisible !== to) {
            this.isVisible = to;
            if (to) {
                this.toggleService.open(PageOffCanvasSearchFormComponent.toggleId);
                this.input?.nativeElement.focus();
            } else {
                this.toggleService.close(PageOffCanvasSearchFormComponent.toggleId);
                this.reset();
            }
        }
    }

    override goToSearchView() {
        this.input?.nativeElement.blur();
        super.goToSearchView();
    }
}
